var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMembersIcon = function SvgMembersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "members-icon_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#members-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "members-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.55 10.679a3.827 3.827 0 1 0-5.105 0 6.12 6.12 0 0 0-3.57 5.567v.878c0 .76.616 1.376 1.375 1.376h9.496c.76 0 1.375-.616 1.375-1.376v-.878c0-2.47-1.463-4.6-3.57-5.567",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.55 10.679-.667-.745-1.135 1.017 1.385.636zm-5.104 0 .417.908 1.386-.636-1.136-1.017zm5.38-2.852c0 .837-.363 1.588-.943 2.107l1.335 1.49a4.82 4.82 0 0 0 1.607-3.597zM8.997 5a2.827 2.827 0 0 1 2.827 2.827h2A4.827 4.827 0 0 0 8.998 3zM6.171 7.827A2.827 2.827 0 0 1 8.998 5V3a4.827 4.827 0 0 0-4.827 4.827zm.942 2.107a2.82 2.82 0 0 1-.942-2.107h-2c0 1.43.622 2.714 1.608 3.597zM6.029 9.77a7.12 7.12 0 0 0-4.154 6.476h2a5.12 5.12 0 0 1 2.988-4.659zm-4.154 6.476v.878h2v-.878zm0 .878A2.376 2.376 0 0 0 4.25 19.5v-2a.376.376 0 0 1-.375-.376zM4.25 19.5h9.496v-2H4.25zm9.496 0a2.376 2.376 0 0 0 2.375-2.376h-2a.376.376 0 0 1-.375.376zm2.375-2.376v-.878h-2v.878zm0-.878a7.12 7.12 0 0 0-4.153-6.476l-.835 1.817a5.12 5.12 0 0 1 2.988 4.66z",
    mask: "url(#members-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.25,
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
};
export default SvgMembersIcon;